import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"

import { CssBaseline } from "@material-ui/core"

import { Notification } from "./elements"

const Layout = ({ children }) => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
      />
      <script src="https://js.stripe.com/v3/" />
    </Helmet>
    <CssBaseline />
    {children}
    <Notification />
  </div>
)

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
